import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <ReviewableTopicLink @reviewable={{@reviewable}} @tagName="">
  <div class="title-text">
    {{d-icon "plus-square" title="review.new_topic"}}
    {{@reviewable.payload.title}}
  </div>
  {{category-badge @reviewable.category}}
  <ReviewableTags @tags={{@reviewable.payload.tags}} @tagName="" />
  {{#if @reviewable.payload.via_email}}
    <a href {{on "click" this.showRawEmail}} class="show-raw-email">
      {{d-icon "envelope" title="post.via_email"}}
    </a>
  {{/if}}
</ReviewableTopicLink>

<div class="post-contents-wrapper">
  <ReviewableCreatedBy @user={{@reviewable.target_created_by}} @tagName="" />

  <div class="post-contents">
    <ReviewablePostHeader
      @reviewable={{@reviewable}}
      @createdBy={{@reviewable.target_created_by}}
      @tagName=""
    />

    <CookText
      class="post-body {{if this.isCollapsed 'is-collapsed'}}"
      @rawText={{@reviewable.payload.raw}}
      @categoryId={{@reviewable.category_id}}
      @topicId={{@reviewable.topic_id}}
      @paintOneboxes={{true}}
      @opts={{hash removeMissing=true}}
      @onOffsetHeightCalculated={{this.setPostBodyHeight}}
    />

    {{#if this.isLongPost}}
      <DButton
        @action={{this.toggleContent}}
        @label={{this.collapseButtonProps.label}}
        @icon={{this.collapseButtonProps.icon}}
        class="btn-default btn-icon post-body__toggle-btn"
      />
    {{/if}}

    {{yield}}
  </div>
</div>
*/
{
  "id": "uqVJBf2/",
  "block": "[[[8,[39,0],null,[[\"@reviewable\",\"@tagName\"],[[30,1],\"\"]],[[\"default\"],[[[[1,\"\\n  \"],[10,0],[14,0,\"title-text\"],[12],[1,\"\\n    \"],[1,[28,[35,1],[\"plus-square\"],[[\"title\"],[\"review.new_topic\"]]]],[1,\"\\n    \"],[1,[30,1,[\"payload\",\"title\"]]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[1,[28,[35,2],[[30,1,[\"category\"]]],null]],[1,\"\\n  \"],[8,[39,3],null,[[\"@tags\",\"@tagName\"],[[30,1,[\"payload\",\"tags\"]],\"\"]],null],[1,\"\\n\"],[41,[30,1,[\"payload\",\"via_email\"]],[[[1,\"    \"],[11,3],[24,6,\"\"],[24,0,\"show-raw-email\"],[4,[38,5],[\"click\",[30,0,[\"showRawEmail\"]]],null],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"envelope\"],[[\"title\"],[\"post.via_email\"]]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null]],[]]]]],[1,\"\\n\\n\"],[10,0],[14,0,\"post-contents-wrapper\"],[12],[1,\"\\n  \"],[8,[39,6],null,[[\"@user\",\"@tagName\"],[[30,1,[\"target_created_by\"]],\"\"]],null],[1,\"\\n\\n  \"],[10,0],[14,0,\"post-contents\"],[12],[1,\"\\n    \"],[8,[39,7],null,[[\"@reviewable\",\"@createdBy\",\"@tagName\"],[[30,1],[30,1,[\"target_created_by\"]],\"\"]],null],[1,\"\\n\\n    \"],[8,[39,8],[[16,0,[29,[\"post-body \",[52,[30,0,[\"isCollapsed\"]],\"is-collapsed\"]]]]],[[\"@rawText\",\"@categoryId\",\"@topicId\",\"@paintOneboxes\",\"@opts\",\"@onOffsetHeightCalculated\"],[[30,1,[\"payload\",\"raw\"]],[30,1,[\"category_id\"]],[30,1,[\"topic_id\"]],true,[28,[37,9],null,[[\"removeMissing\"],[true]]],[30,0,[\"setPostBodyHeight\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"isLongPost\"]],[[[1,\"      \"],[8,[39,10],[[24,0,\"btn-default btn-icon post-body__toggle-btn\"]],[[\"@action\",\"@label\",\"@icon\"],[[30,0,[\"toggleContent\"]],[30,0,[\"collapseButtonProps\",\"label\"]],[30,0,[\"collapseButtonProps\",\"icon\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[18,2,null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@reviewable\",\"&default\"],false,[\"reviewable-topic-link\",\"d-icon\",\"category-badge\",\"reviewable-tags\",\"if\",\"on\",\"reviewable-created-by\",\"reviewable-post-header\",\"cook-text\",\"hash\",\"d-button\",\"yield\"]]",
  "moduleName": "discourse/components/reviewable-queued-post.hbs",
  "isStrictMode": false
});